import { useEffect, useRef } from 'react'

export default function useOutsideClick(callback) {

  const ref = useRef();

  useEffect(() => {
    const handleClick = (e) => {
      console.log(' <^> Document...');
      if (ref.current && !ref.current.contains(e.target)) {       
        callback();
      }
    }

    document.addEventListener('click', handleClick);

    return () => {
      document.removeEventListener('click', handleClick);
    }
  }, [ref, callback]);

  return ref;
};
